export enum DocumentLineStatus {
    None = 0,
    AutomaticReorder = 5,
    RowError = 7,
    Nota24 = 8,
    FromShoppingCart = 9,
    OkForTransmission = 10,
    NotTransmitted = 19,
    Transmitted = 20,
    NotConfirmed = 24,
    PartialConfirmed = 25,
    SpeciallyOrdered = 26,
    Confirmed = 30,
    StockUpdated = 60,
}